import Collection from '@/components/Collection'
import LogField from '@/components/LogField'
import ViewLog from '@/pages/log/Detail'
import access from '../access'

function formatTimeStamp(s) {
  let e = new Date(s * 1000);
  return e.toLocaleString()
}

function decodeResponseCode(code) {
  let codes = {
    "1000": "Command completed successfully",
    "1001": "Command completed successfully; action pending",
    "1300": "Command completed successfully; no messages",
    "1301": "Command completed successfully; ack to dequeue",
    "1500": "Command completed successfully; ending session",
    "2000": "Unknown command",
    "2001": "Command syntax error",
    "2002": "Command use error",
    "2003": "Required parameter missing",
    "2004": "Parameter value range error",
    "2005": "Parameter value syntax error",
    "2100": "Unimplemented protocol version",
    "2101": "Unimplemented command",
    "2102": "Unimplemented option",
    "2103": "Unimplemented extension",
    "2104": "Billing failure",
    "2105": "Object is not eligible for renewal",
    "2106": "Object is not eligible for transfer",
    "2200": "Authentication error",
    "2201": "Authorization error",
    "2202": "Invalid authorization information",
    "2300": "Object pending transfer",
    "2301": "Object not pending transfer",
    "2302": "Object exists",
    "2303": "Object does not exist",
    "2304": "Object status prohibits operation",
    "2305": "Object association prohibits operation",
    "2306": "Parameter value policy error",
    "2307": "Unimplemented object service",
    "2308": "Data management policy violation",
    "2400": "Command failed",
    "2500": "Command failed; server closing connection",
    "2501": "Authentication error; server closing connection",
    "2502": "Session limit exceeded; server closing connection",
    "200": "HTTP OK",
    "400": "HTTP Bad request",
    "401": "HTTP Unauthorized",
    "403": "HTTP Forbidden",
    "404": "HTTP Not found",
    "406": "HTTP Not acceptable",
    "409": "HTTP Conflict",
    "412": "HTTP Precondition failed",
    "422": "HTTP Unprocessable entity",
    "500": "HTTP Internal server error"
  };

  if (code in codes) {
    return codes[code]
  }

  return code
}

function formatMilliSeconds(n, round) {
  if (n === 0) {
    return "0 ms"
  }

  if (n < 1000000) {
    if (round) {
      return Math.round((n / 1000) * 100) / 100 + " μs"
    } else {
      return (n / 1000) + " μs"
    }
  }

  if (round) {
    return Math.round((n / 1000000) * 100) / 100 + " ms"
  } else {
    return (n / 1000000) + " ms"
  }
}

function formatBytes(n) {
  return Math.round((n / 1024) * 100) / 100 + " kB"
}

function formatSession(s) {
  return s.split("-")[0]
}

export default {

  'log.collection':{
    path: '/admin/logs',
    name: 'log.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listLogs",
      entity: "log",
      cols: [
        {
          label: "Date",
          sort: "timestamp",
          component: LogField,
          componentProps: (row) => {
            let ts = new Date(row.timestamp * 1000);
            let d = ts.getFullYear() + "-" + (ts.getMonth()+1) + "-" + ts.getDate();
            return {
              filter: {date_from: d, date_to: d},
              display: formatTimeStamp(row.timestamp),
              active: true,
            };
          },
        },
        {
          label: "Registrar",
          sort: "registrar",
          component: LogField,
          componentProps: (row) => {
            return {
              filter: {registrar: row.registrar},
              display: String(row.registrar),
              active: true,
            };
          }
        },
        {
          label: "Command",
          sort: "command",
          component: LogField,
          componentProps: (row) => {
            return {
              filter: {command: row.command},
              display: row.command,
              active: true,
            };
          }
        },
        {
          label: "Subject",
          sort: "object",
          component: LogField,
          componentProps: (row) => {
            return {
              filter: {object: row.object},
              display: row.object,
              active: true,
            };
          }
        },
        {
          label: "Result",
          html: (row) => '<span class="hover-help" title="' + decodeResponseCode(row.code) + '">' + row.code + '</span>'
        },
        { label: "Message", field: "message" },
        {
          label: "Duration",
          sort: "duration",
          html: (row) => '<span class="hover-help" title="' + formatMilliSeconds(row.duration, false) + '">' + formatMilliSeconds(row.duration, true) + '</span>'
        },
        { label: "Received", sort: "request_size", html: (row) => formatBytes(row.request_size) },
        { label: "Sent", sort: "response_size", html: (row) => formatBytes(row.response_size) },
        {
          label: "Session",
          sort: "session",
          component: LogField,
          componentProps: (row) => {
            return {
              filter: {session: row.session},
              display: row.session.indexOf('?') === -1 ? '<span class="hover-help" title="' + row.session + '">' + formatSession(row.session) + '</span>' : row.session,
              active: row.session.indexOf('?') === -1
            };
          }
        },
        { label: "clTRID", field: "client_trid" },
      ],
      actions: (row) => {
        return [
          { name: "log.view", label: "view", icon: "eye", params: {id: row.id} }
        ];
      }
    },
    meta: {
      access: access.admin,
      title: "Log history",
      side_menu: { label: "Logs",  icon: "database", weight: 100 },
    },
  },

  'log.view': {
    path: '/admin/logs/view/:id',
    name: 'log.view',
    component: ViewLog,
    props: true,
    meta: {
      access: access.admin,
      title: "Log details"
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/log.js